import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";
import { topics } from "@/mocks/home";

export default function TopicIndexSection() {
  return (
    <section id="topics" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <Reveal>
          <SectionHeading
            index="01"
            eyebrow="Collection Index"
            title="全站专题合集索引"
            description="我们把零散线报按产业链归拢成合集。每条合集都标注了材料数量与核验状态，方便你按线索找下去。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 border-y border-background-200 py-4">
            <span className="text-xs tracking-[0.2em] text-foreground-400">合集</span>
            {topics.map((topic) => (
              <a
                key={topic.no}
                href="#topics"
                className="group inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                <span className="font-heading text-xs text-primary-500">{topic.no}</span>
                {topic.title.replace(/链$|闭环$|网$/, "")}
                <span className="text-foreground-300 group-hover:text-primary-400">/</span>
              </a>
            ))}
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-x-7 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic, index) => (
            <Reveal key={topic.no} delay={index * 60} className={index === 0 ? "sm:col-span-2 lg:col-span-2" : ""}>
              <a href="#topics" className="group block cursor-pointer">
                <div
                  className={`relative w-full overflow-hidden rounded-lg bg-foreground-950 ${
                    index === 0 ? "h-[240px] md:h-[360px]" : "h-[220px] md:h-[260px]"
                  }`}
                >
                  <img
                    src={topic.image}
                    alt={`黑网爆料专题合集：${topic.title}`}
                    title={`${topic.title} 黑网爆料 黑灰产 地下市场`}
                    className="h-full w-full object-cover object-top transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/15 to-transparent"></div>
                  <span className="absolute left-4 top-4 font-heading text-2xl text-background-50/85 md:text-3xl">
                    {topic.no}
                  </span>
                  <span className="absolute right-4 top-4 rounded-full border border-background-50/30 bg-foreground-950/50 px-3 py-1 text-xs text-background-100">
                    {topic.tag}
                  </span>
                  <div className="absolute inset-x-4 bottom-4">
                    <h3 className="font-heading text-lg text-background-50 md:text-xl">
                      {topic.title}
                    </h3>
                  </div>
                </div>
                <div className="mt-5 flex items-start justify-between gap-4">
                  <p className="max-w-md text-sm leading-7 text-foreground-600">
                    {topic.desc}
                  </p>
                  <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                    {topic.count}
                    <i className="ri-arrow-right-up-line text-primary-500 transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}